import { useMessages, useTranslations } from 'next-intl'

export const useFormTranslations = (formContext?: string) => {
  const formNamespace = 'commerce-blocks.form'
  const formOverrideNamespace = `commerce-blocks.${formContext}-form`

  const t1 = useTranslations(formNamespace)
  const t2 = useTranslations(
    formContext ? formOverrideNamespace : formNamespace
  )

  const messages = useMessages()
  const overrideMessages =
    formContext && messages['commerce-blocks'][`${formContext}-form`]

  return (
    key: string,
    args?: Record<string, string | number | Date>
  ): string => {
    key = key.startsWith('validation') ? key : `fields.${key}`
    const [scope, field, property] = key.split('.')
    if (formContext && overrideMessages?.[scope]?.[field]?.[property]) {
      const translation = t2(key, args)

      if (translation !== `${formOverrideNamespace}.${key}`) {
        return translation
      }
    }

    const translation = t1(key, args)

    if (translation !== `${formNamespace}.${key}`) {
      return translation
    }

    return key
  }
}
